import { find } from 'lodash';
import country from '@/constants/country';

export const getCountry = (id) => find(country, { id }) || {};
